<template>
  <div :style="containerStyle">
    <template v-if="isFirstPage">
      <i class="material-icons"
         :style="firstPageStyle">
        first_page
      </i>
    </template>
    <template v-else>
      <i class="material-icons"
         :style="leftStyle"
         @click="decrementPage">
        chevron_left
      </i>
    </template>
    <template v-if="isLastPage">
      <i class="material-icons"
         :style="lastPageStyle">
        last_page
      </i>
    </template>
    <template v-else>
      <i class="material-icons"
         :style="rightStyle"
         @click="incrementPage">
        chevron_right
      </i>
    </template>

  </div>
</template>

<script>
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'PaginationSecondary',
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    props: {
      vmodelValue: { type: Number },
      pageSize: { type: Number, required: false, default: 1 },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
        },
        firstPageStyle: {
          content: 'first_page',
          cursor: 'pointer',
          fontSize: '20px',
        },
        lastPageStyle: {
          content: 'last_page',
          cursor: 'pointer',
          fontSize: '20px',
        },
        leftStyle: {
          content: 'chevron_left',
          cursor: 'pointer',
          fontSize: '20px',
        },
        page: 1,
        rightStyle: {
          content: 'chevron_right',
          cursor: 'pointer',
          fontSize: '20px',
        },
      };
    },
    created: function () {
      this.firstPageStyle = {
        ...this.firstPageStyle,
        color: this.color.dark5(),
      };

      this.lastPageStyle = {
        ...this.lastPageStyle,
        color: this.color.dark5(),
      };

      this.leftStyle = {
        ...this.leftStyle,
        color: this.color.dark3(),
      };

      this.rightStyle = {
        ...this.rightStyle,
        color: this.color.dark3(),
      };

      this.page = this.vmodelValue;
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      isFirstPage: function () {
        return this.page === 1;
      },
      isLastPage: function () {
        return this.page === this.pageSize;
      },
    },
    methods: {
      decrementPage: function () {
        if (this.page <= 1) {
          this.page = 1;
        } else {
          this.page--;
        }
        this.$emit('change', this.page);
      },
      incrementPage: function () {
        if (this.page >= this.pageSize) {
          this.page = this.pageSize;
        } else {
          this.page++;
        }
        this.$emit('change', this.page);
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.page = newVal;
      },
    },
  };
</script>
